import React from 'react';
import Container from 'react-bootstrap/Container';
import {Message, Loading} from '@aperza/ui';
import PropTypes from "prop-types";
import type AppConfig from "../../domain/AppConfig";
import AppService from "../../service/AppService";

import CatalogList from './CatalogList';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';

const appConfig: AppConfig = AppService.appConfig();

const CatalogDownloadSuccessPanel = props => {

  let {
    documentId,
  } = props;

  let {loading, error, data} = useQuery(GET_CATALOG, {
    variables: {
      documentId,
    }
  });

  let catalog = (!loading && data && data.viewer) ? data.viewer.catalog : {};
  let recommendCatalogs = (!loading && data && data.viewer) ? data.viewer.recommendCatalogs : {};

  return (
    <Container fluid="true" className="aw-form download-complete-panel">
      <h1 className="download-complete-title"><Message messageId={'thanksDownload'}/></h1>
      <p className="download-complete-subTxt">
        <Message messageId={'downloadCompleteMessage'}/><br/>
        <Message messageId={'downloadCompleteMessage2'}/>
      </p>
      {loading && <Loading />}
      {!loading &&
        <>
      <table className="table table-1 mt-5" id="catalog-modal-table">
        <thead>
        <tr>
          <th width="70%"><Message messageId={'catalog'}/></th>
          <th width="30%">企業名</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td><a href={`${appConfig.searchWebHost}${catalog.catalog.catalogPath}`}
                 target="_blank">{catalog.catalog.documentName}</a>
          </td>
          <td><a href={`${appConfig.searchWebHost}${catalog.catalog.companyPath}`}
                 target="_blank">{catalog.catalog.companyNameLangValue}</a>
          </td>
        </tr>
        </tbody>
      </table>
      <p className="download-complete-subTxt">過去にダウンロードした<Message messageId={'catalog'}/>は、「
        <a href={`${appConfig.accountWebHost}/history`} target="_blank" className="td-click text-link"
           data-track='{"parts":"downloading","position":"2","id_index":"1"}'>
          MyPageのダウンロード履歴
        </a>」からご確認いただけます。
      </p>
      <h2 className="recommend-catalog-title">ダウンロードしたカタログの関連商品</h2>
      <div id="recommend-catalog-list">
        <Container fluid="true">
          <CatalogList columns="4" catalogs={recommendCatalogs} disablePreview={true}/>
        </Container>
      </div>
      </>
        }
    </Container>
  )

};

CatalogDownloadSuccessPanel.fragments = {
  viewer: gql`
      fragment CatalogDownloadSuccessPanelDemo_viewer on Viewer {
          catalog(documentId:$documentId) {
              catalog {
                  companyContractDisplayId
                  cluezCatalogId
                  documentName
                  companyNameLangValue
                  catalogPath
                  companyPath
              }
          }
          recommendCatalogs(documentId:$documentId) {
              catalog {
                  cluezCatalogId
                  cluezCompanyId
                  cluezCategoryIdPath
                  imageUrl1
                  previewImageUrl1
                  previewImageUrl2
                  previewImageUrl3
                  previewImageUrl4
                  videoUrl
                  documentGroupId
                  documentDisplayId
                  documentName
                  documentOriginalName
                  documentSubName
                  documentUrl
                  documentSizeBytes
                  documentDescription
                  documentPublishFlag
                  documentConversionFlag
                  documentExternalSiteFlag
                  companyContractId
                  companyContractDisplayId
                  companyNameLangValue
                  companyLogoUrlLangValue
                  catalogId
                  humanFileSize
              }
              brand {
                  brandId
                  urlId
                  nameLangValue
                  manufacturerBrandImageLangValue
              }
              document {
                  documentId
                  documentType
                  documentUrl
                  documentDisplayId
                  documentSubName
                  documentPublishFlag
                  documentConversionFlag
                  documentDescription
                  documentExternalSiteFlag
                  documentGroupId
                  documentName
                  documentOriginalName
                  documentSizeBytes
                  displayDocumentOriginalName
                  langKey
                  firstDocumentImageUrl
                  humanFileSize
              }
              label
              langKey
              humanFileSize
              firstDocumentImageUrl
              displayDocumentOriginalName
              _score
          }

      }
  `
}

// CatalogDownloadSuccessPanel.fragments = {
//   viewer: gql`
//       fragment CatalogDownloadSuccessPanelDemo_viewer on Viewer {
//           downloadCatalog(cluezCatalogId:$catalogId) {
//               status
//               catalogId
//               catalogName
//               catalogPath
//               companyId
//               companyName
//               companyPath
// //
//               recommendCatalogs {
//                   catalog {
//                       cluezCatalogId
//                       cluezCompanyId
//                       cluezCategoryIdPath
//                       imageUrl1
//                       previewImageUrl1
//                       previewImageUrl2
//                       previewImageUrl3
//                       previewImageUrl4
//                       videoUrl
//                       documentGroupId
//                       documentDisplayId
//                       documentName
//                       documentOriginalName
//                       documentSubName
//                       documentUrl
//                       documentSizeBytes
//                       documentDescription
//                       documentPublishFlag
//                       documentConversionFlag
//                       documentExternalSiteFlag
//                       companyContractId
//                       companyContractDisplayId
//                       companyNameLang
//                       companyLogoUrlLang
//                       catalogId
//                       humanFileSize
//                   }
//                   brand {
//                       brandId
//                       urlId
//                       nameLangValue
//                       manufacturerBrandImageLangValue
//                   }
//                   document {
//                       documentId
//                       documentType
//                       documentUrl
//                       documentDisplayId
//                       documentSubName
//                       documentPublishFlag
//                       documentConversionFlag
//                       documentDescription
//                       documentExternalSiteFlag
//                       documentGroupId
//                       documentName
//                       documentOriginalName
//                       documentSizeBytes
//                       displayDocumentOriginalName
//                       langKey
//                       firstDocumentImageUrl
//                       humanFileSize
//                   }
//                   label
//                   langKey
//                   humanFileSize
//                   firstDocumentImageUrl
//                   displayDocumentOriginalName
//                   _score
//               }
//           }
//       }
//   `
// };

const GET_CATALOG = gql`
    query getCatalog($documentId: String!)
    {
        viewer {
            id
            ...CatalogDownloadSuccessPanelDemo_viewer
        }
    }
    ${CatalogDownloadSuccessPanel.fragments.viewer}
`;

CatalogDownloadSuccessPanel.propTypes = {
  documentId: PropTypes.string.isRequired,
};

export default CatalogDownloadSuccessPanel;
